import { Suspense } from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate
} from "react-router-dom"
import { SocketProvider } from "../contexts/socket";
import { SocketContentProvider } from "../contexts/socket-content";
import { TradePriceProvider } from "../contexts/trade-price";
import TradeDashboard from "./TradeDashboard";
import Otc from "./Otc";
import Markets from "./Markets";
import GlobalLoading from "../components/common/loading/GlobalLoading";
import DraggableDashboard from "./DraggableDashboard";
import {useCheckToken} from "../services/react-query/useProfileQuery";


const Index = () => {

    useCheckToken()

    return (
        <Router basename={process.env.PUBLIC_URL}>
            <Suspense fallback={<GlobalLoading />}>
                <Routes>
                    {routes.map((route, idx) => (
                        <Route key={route.path} index={idx === 0} path={route.path} element={
                            <SocketProvider>
                                <SocketContentProvider>
                                    <TradePriceProvider>
                                        {route.element}
                                    </TradePriceProvider>
                                </SocketContentProvider>
                            </SocketProvider>
                        } />
                    ))}
                    <Route path="*" element={<Navigate to="/BTC_IRT" replace />} />
                </Routes>
            </Suspense>
        </Router>
    )
}

const routes = [
    {path: '/:id', element: <TradeDashboard />},
    {path: '/markets', element: <Markets />},
    {path: '/form', element: <Otc />},
    {path:'/edit', element: <DraggableDashboard />}
]


export default Index;
